import { h, Component } from 'preact'
import styles from './App.css'
import { Header } from './header/header'
import { ShortExplainer } from './short-explainer/short-explainer'
import { Section } from './section/section'
// import { Latest } from './latest/latest'
import { Footer } from './footer/footer'
import { Menu } from './menu/menu'
interface Props {
  title: string
  isLive: boolean
  shortExplainer: any
  sections: any[]
  meta?: any
  byline?: any
  latest?: any
  polopolyId?: any
  showPublicationDate?: boolean
}
const articlesWithHiddenExplainer = ['1.14960213', '1.15227270']
const hasMenu = ['1.14961835', '1.14967782', '1.14961836']
export class App extends Component<Props, {}> {
  render() {
    const {
      title,
      isLive,
      shortExplainer,
      sections = [],
      meta,
      byline,
      polopolyId,
      showPublicationDate,
    } = this.props
    const hideExplainer =
      !shortExplainer ||
      !shortExplainer.length ||
      articlesWithHiddenExplainer.indexOf(polopolyId) !== -1
    const showMenu = hasMenu.indexOf(polopolyId) !== -1
    const mappedSections = sections.map((section) => (
      <Section {...section} stickyTitles={showMenu} />
    ))
    return (
      <div class={styles.app}>
        <Header title={title} isLive={isLive} hideSubtitle={hideExplainer} />
        {!hideExplainer && <ShortExplainer data={shortExplainer} />}
        {showMenu ? <Menu sections={sections} /> : null}
        {mappedSections}
        {/* <Latest data={latest} /> */}
        <Footer meta={meta} byline={byline} showPublicationDate={showPublicationDate} />
        {/* <pre>{JSON.stringify(this.props, null, 2)}</pre> */}
      </div>
    )
  }
}
